;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="8c218007-6dcb-431c-8beb-8a97f935033b",e._sentryDebugIdIdentifier="sentry-dbid-8c218007-6dcb-431c-8beb-8a97f935033b")}catch(e){}}();
"use strict";
(self["webpackChunkretino"] = self["webpackChunkretino"] || []).push([[538],{

/***/ 2538:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: () => (/* binding */ BackendPublicEnums)
/* harmony export */ });
/* eslint-disable no-shadow */
let BackendPublicEnums;
(function (_BackendPublicEnums) {
  let AccountRegisterLanguageEnum = /*#__PURE__*/function (AccountRegisterLanguageEnum) {
    AccountRegisterLanguageEnum["CS"] = "cs";
    AccountRegisterLanguageEnum["EN"] = "en";
    AccountRegisterLanguageEnum["HU"] = "hu";
    AccountRegisterLanguageEnum["RO"] = "ro";
    return AccountRegisterLanguageEnum;
  }({});
  _BackendPublicEnums.AccountRegisterLanguageEnum = AccountRegisterLanguageEnum;
  let AmountOfShippingsEnum = /*#__PURE__*/function (AmountOfShippingsEnum) {
    AmountOfShippingsEnum[AmountOfShippingsEnum["VALUE_1"] = 1] = "VALUE_1";
    AmountOfShippingsEnum[AmountOfShippingsEnum["VALUE_2"] = 2] = "VALUE_2";
    AmountOfShippingsEnum[AmountOfShippingsEnum["VALUE_3"] = 3] = "VALUE_3";
    AmountOfShippingsEnum[AmountOfShippingsEnum["VALUE_4"] = 4] = "VALUE_4";
    AmountOfShippingsEnum[AmountOfShippingsEnum["VALUE_5"] = 5] = "VALUE_5";
    return AmountOfShippingsEnum;
  }({});
  _BackendPublicEnums.AmountOfShippingsEnum = AmountOfShippingsEnum;
  let BillingCurrencyEnum = /*#__PURE__*/function (BillingCurrencyEnum) {
    BillingCurrencyEnum["CZK"] = "CZK";
    BillingCurrencyEnum["EUR"] = "EUR";
    return BillingCurrencyEnum;
  }({});
  _BackendPublicEnums.BillingCurrencyEnum = BillingCurrencyEnum;
  let CountryEnum = /*#__PURE__*/function (CountryEnum) {
    CountryEnum["AF"] = "AF";
    CountryEnum["AX"] = "AX";
    CountryEnum["AL"] = "AL";
    CountryEnum["DZ"] = "DZ";
    CountryEnum["AS"] = "AS";
    CountryEnum["AD"] = "AD";
    CountryEnum["AO"] = "AO";
    CountryEnum["AI"] = "AI";
    CountryEnum["AQ"] = "AQ";
    CountryEnum["AG"] = "AG";
    CountryEnum["AR"] = "AR";
    CountryEnum["AM"] = "AM";
    CountryEnum["AW"] = "AW";
    CountryEnum["AU"] = "AU";
    CountryEnum["AT"] = "AT";
    CountryEnum["AZ"] = "AZ";
    CountryEnum["BS"] = "BS";
    CountryEnum["BH"] = "BH";
    CountryEnum["BD"] = "BD";
    CountryEnum["BB"] = "BB";
    CountryEnum["BY"] = "BY";
    CountryEnum["BE"] = "BE";
    CountryEnum["BZ"] = "BZ";
    CountryEnum["BJ"] = "BJ";
    CountryEnum["BM"] = "BM";
    CountryEnum["BT"] = "BT";
    CountryEnum["BO"] = "BO";
    CountryEnum["BQ"] = "BQ";
    CountryEnum["BA"] = "BA";
    CountryEnum["BW"] = "BW";
    CountryEnum["BV"] = "BV";
    CountryEnum["BR"] = "BR";
    CountryEnum["IO"] = "IO";
    CountryEnum["BN"] = "BN";
    CountryEnum["BG"] = "BG";
    CountryEnum["BF"] = "BF";
    CountryEnum["BI"] = "BI";
    CountryEnum["CV"] = "CV";
    CountryEnum["KH"] = "KH";
    CountryEnum["CM"] = "CM";
    CountryEnum["CA"] = "CA";
    CountryEnum["KY"] = "KY";
    CountryEnum["CF"] = "CF";
    CountryEnum["TD"] = "TD";
    CountryEnum["CL"] = "CL";
    CountryEnum["CN"] = "CN";
    CountryEnum["CX"] = "CX";
    CountryEnum["CC"] = "CC";
    CountryEnum["CO"] = "CO";
    CountryEnum["KM"] = "KM";
    CountryEnum["CD"] = "CD";
    CountryEnum["CG"] = "CG";
    CountryEnum["CK"] = "CK";
    CountryEnum["CR"] = "CR";
    CountryEnum["CI"] = "CI";
    CountryEnum["HR"] = "HR";
    CountryEnum["CU"] = "CU";
    CountryEnum["CW"] = "CW";
    CountryEnum["CY"] = "CY";
    CountryEnum["CZ"] = "CZ";
    CountryEnum["DK"] = "DK";
    CountryEnum["DJ"] = "DJ";
    CountryEnum["DM"] = "DM";
    CountryEnum["DO"] = "DO";
    CountryEnum["EC"] = "EC";
    CountryEnum["EG"] = "EG";
    CountryEnum["SV"] = "SV";
    CountryEnum["GQ"] = "GQ";
    CountryEnum["ER"] = "ER";
    CountryEnum["EE"] = "EE";
    CountryEnum["ET"] = "ET";
    CountryEnum["FK"] = "FK";
    CountryEnum["FO"] = "FO";
    CountryEnum["FJ"] = "FJ";
    CountryEnum["FI"] = "FI";
    CountryEnum["FR"] = "FR";
    CountryEnum["GF"] = "GF";
    CountryEnum["PF"] = "PF";
    CountryEnum["TF"] = "TF";
    CountryEnum["GA"] = "GA";
    CountryEnum["GM"] = "GM";
    CountryEnum["GE"] = "GE";
    CountryEnum["DE"] = "DE";
    CountryEnum["GH"] = "GH";
    CountryEnum["GI"] = "GI";
    CountryEnum["GR"] = "GR";
    CountryEnum["GL"] = "GL";
    CountryEnum["GD"] = "GD";
    CountryEnum["GP"] = "GP";
    CountryEnum["GU"] = "GU";
    CountryEnum["GT"] = "GT";
    CountryEnum["GG"] = "GG";
    CountryEnum["GN"] = "GN";
    CountryEnum["GW"] = "GW";
    CountryEnum["GY"] = "GY";
    CountryEnum["HT"] = "HT";
    CountryEnum["HM"] = "HM";
    CountryEnum["VA"] = "VA";
    CountryEnum["HN"] = "HN";
    CountryEnum["HK"] = "HK";
    CountryEnum["HU"] = "HU";
    CountryEnum["IS"] = "IS";
    CountryEnum["IN"] = "IN";
    CountryEnum["ID"] = "ID";
    CountryEnum["IR"] = "IR";
    CountryEnum["IQ"] = "IQ";
    CountryEnum["IE"] = "IE";
    CountryEnum["IM"] = "IM";
    CountryEnum["IL"] = "IL";
    CountryEnum["IT"] = "IT";
    CountryEnum["JM"] = "JM";
    CountryEnum["JP"] = "JP";
    CountryEnum["JE"] = "JE";
    CountryEnum["JO"] = "JO";
    CountryEnum["KZ"] = "KZ";
    CountryEnum["KE"] = "KE";
    CountryEnum["KI"] = "KI";
    CountryEnum["KP"] = "KP";
    CountryEnum["KR"] = "KR";
    CountryEnum["KW"] = "KW";
    CountryEnum["KG"] = "KG";
    CountryEnum["LA"] = "LA";
    CountryEnum["LV"] = "LV";
    CountryEnum["LB"] = "LB";
    CountryEnum["LS"] = "LS";
    CountryEnum["LR"] = "LR";
    CountryEnum["LY"] = "LY";
    CountryEnum["LI"] = "LI";
    CountryEnum["LT"] = "LT";
    CountryEnum["LU"] = "LU";
    CountryEnum["MO"] = "MO";
    CountryEnum["MK"] = "MK";
    CountryEnum["MG"] = "MG";
    CountryEnum["MW"] = "MW";
    CountryEnum["MY"] = "MY";
    CountryEnum["MV"] = "MV";
    CountryEnum["ML"] = "ML";
    CountryEnum["MT"] = "MT";
    CountryEnum["MH"] = "MH";
    CountryEnum["MQ"] = "MQ";
    CountryEnum["MR"] = "MR";
    CountryEnum["MU"] = "MU";
    CountryEnum["YT"] = "YT";
    CountryEnum["MX"] = "MX";
    CountryEnum["FM"] = "FM";
    CountryEnum["MD"] = "MD";
    CountryEnum["MC"] = "MC";
    CountryEnum["MN"] = "MN";
    CountryEnum["ME"] = "ME";
    CountryEnum["MS"] = "MS";
    CountryEnum["MA"] = "MA";
    CountryEnum["MZ"] = "MZ";
    CountryEnum["MM"] = "MM";
    CountryEnum["NA"] = "NA";
    CountryEnum["NR"] = "NR";
    CountryEnum["NP"] = "NP";
    CountryEnum["NL"] = "NL";
    CountryEnum["NC"] = "NC";
    CountryEnum["NZ"] = "NZ";
    CountryEnum["NI"] = "NI";
    CountryEnum["NE"] = "NE";
    CountryEnum["NG"] = "NG";
    CountryEnum["NU"] = "NU";
    CountryEnum["NF"] = "NF";
    CountryEnum["MP"] = "MP";
    CountryEnum["NO"] = "NO";
    CountryEnum["OM"] = "OM";
    CountryEnum["PK"] = "PK";
    CountryEnum["PW"] = "PW";
    CountryEnum["PS"] = "PS";
    CountryEnum["PA"] = "PA";
    CountryEnum["PG"] = "PG";
    CountryEnum["PY"] = "PY";
    CountryEnum["PE"] = "PE";
    CountryEnum["PH"] = "PH";
    CountryEnum["PN"] = "PN";
    CountryEnum["PL"] = "PL";
    CountryEnum["PT"] = "PT";
    CountryEnum["PR"] = "PR";
    CountryEnum["QA"] = "QA";
    CountryEnum["RE"] = "RE";
    CountryEnum["RO"] = "RO";
    CountryEnum["RU"] = "RU";
    CountryEnum["RW"] = "RW";
    CountryEnum["BL"] = "BL";
    CountryEnum["SH"] = "SH";
    CountryEnum["KN"] = "KN";
    CountryEnum["LC"] = "LC";
    CountryEnum["MF"] = "MF";
    CountryEnum["PM"] = "PM";
    CountryEnum["VC"] = "VC";
    CountryEnum["WS"] = "WS";
    CountryEnum["SM"] = "SM";
    CountryEnum["ST"] = "ST";
    CountryEnum["SA"] = "SA";
    CountryEnum["SN"] = "SN";
    CountryEnum["RS"] = "RS";
    CountryEnum["SC"] = "SC";
    CountryEnum["SL"] = "SL";
    CountryEnum["SG"] = "SG";
    CountryEnum["SX"] = "SX";
    CountryEnum["SK"] = "SK";
    CountryEnum["SI"] = "SI";
    CountryEnum["SB"] = "SB";
    CountryEnum["SO"] = "SO";
    CountryEnum["ZA"] = "ZA";
    CountryEnum["GS"] = "GS";
    CountryEnum["SS"] = "SS";
    CountryEnum["ES"] = "ES";
    CountryEnum["LK"] = "LK";
    CountryEnum["SD"] = "SD";
    CountryEnum["SR"] = "SR";
    CountryEnum["SJ"] = "SJ";
    CountryEnum["SZ"] = "SZ";
    CountryEnum["SE"] = "SE";
    CountryEnum["CH"] = "CH";
    CountryEnum["SY"] = "SY";
    CountryEnum["TW"] = "TW";
    CountryEnum["TJ"] = "TJ";
    CountryEnum["TZ"] = "TZ";
    CountryEnum["TH"] = "TH";
    CountryEnum["TL"] = "TL";
    CountryEnum["TG"] = "TG";
    CountryEnum["TK"] = "TK";
    CountryEnum["TO"] = "TO";
    CountryEnum["TT"] = "TT";
    CountryEnum["TN"] = "TN";
    CountryEnum["TR"] = "TR";
    CountryEnum["TM"] = "TM";
    CountryEnum["TC"] = "TC";
    CountryEnum["TV"] = "TV";
    CountryEnum["UG"] = "UG";
    CountryEnum["UA"] = "UA";
    CountryEnum["AE"] = "AE";
    CountryEnum["GB"] = "GB";
    CountryEnum["UM"] = "UM";
    CountryEnum["US"] = "US";
    CountryEnum["UY"] = "UY";
    CountryEnum["UZ"] = "UZ";
    CountryEnum["VU"] = "VU";
    CountryEnum["VE"] = "VE";
    CountryEnum["VN"] = "VN";
    CountryEnum["VG"] = "VG";
    CountryEnum["VI"] = "VI";
    CountryEnum["WF"] = "WF";
    CountryEnum["EH"] = "EH";
    CountryEnum["YE"] = "YE";
    CountryEnum["ZM"] = "ZM";
    CountryEnum["ZW"] = "ZW";
    return CountryEnum;
  }({});
  _BackendPublicEnums.CountryEnum = CountryEnum;
  let CurrencyEnum = /*#__PURE__*/function (CurrencyEnum) {
    CurrencyEnum["AUD"] = "AUD";
    CurrencyEnum["BGN"] = "BGN";
    CurrencyEnum["CAD"] = "CAD";
    CurrencyEnum["CHF"] = "CHF";
    CurrencyEnum["CZK"] = "CZK";
    CurrencyEnum["DKK"] = "DKK";
    CurrencyEnum["EUR"] = "EUR";
    CurrencyEnum["GBP"] = "GBP";
    CurrencyEnum["HRK"] = "HRK";
    CurrencyEnum["HUF"] = "HUF";
    CurrencyEnum["ILS"] = "ILS";
    CurrencyEnum["JPY"] = "JPY";
    CurrencyEnum["MXN"] = "MXN";
    CurrencyEnum["NOK"] = "NOK";
    CurrencyEnum["PLN"] = "PLN";
    CurrencyEnum["RON"] = "RON";
    CurrencyEnum["SEK"] = "SEK";
    CurrencyEnum["SGD"] = "SGD";
    CurrencyEnum["THB"] = "THB";
    CurrencyEnum["UAH"] = "UAH";
    CurrencyEnum["USD"] = "USD";
    return CurrencyEnum;
  }({});
  _BackendPublicEnums.CurrencyEnum = CurrencyEnum;
  let CustomFieldTypeEnum = /*#__PURE__*/function (CustomFieldTypeEnum) {
    CustomFieldTypeEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    CustomFieldTypeEnum["CHAR"] = "CHAR";
    CustomFieldTypeEnum["DATE"] = "DATE";
    CustomFieldTypeEnum["MULTILINE"] = "MULTILINE";
    CustomFieldTypeEnum["NUMERIC"] = "NUMERIC";
    CustomFieldTypeEnum["BOOL"] = "BOOL";
    CustomFieldTypeEnum["SELECT"] = "SELECT";
    CustomFieldTypeEnum["SELECTMULTI"] = "SELECTMULTI";
    CustomFieldTypeEnum["URL"] = "URL";
    CustomFieldTypeEnum["FILE"] = "FILE";
    CustomFieldTypeEnum["CZECH_BANK_ACCOUNT"] = "CZECH_BANK_ACCOUNT";
    CustomFieldTypeEnum["IBAN"] = "IBAN";
    return CustomFieldTypeEnum;
  }({});
  _BackendPublicEnums.CustomFieldTypeEnum = CustomFieldTypeEnum;
  let CustomerPaidShippingRatingRatingIntuitivityEnum = /*#__PURE__*/function (CustomerPaidShippingRatingRatingIntuitivityEnum) {
    CustomerPaidShippingRatingRatingIntuitivityEnum["YES"] = "YES";
    CustomerPaidShippingRatingRatingIntuitivityEnum["MAYBE"] = "MAYBE";
    CustomerPaidShippingRatingRatingIntuitivityEnum["NO"] = "NO";
    return CustomerPaidShippingRatingRatingIntuitivityEnum;
  }({});
  _BackendPublicEnums.CustomerPaidShippingRatingRatingIntuitivityEnum = CustomerPaidShippingRatingRatingIntuitivityEnum;
  let CustomerPaidShippingRatingRatingProblemsEnum = /*#__PURE__*/function (CustomerPaidShippingRatingRatingProblemsEnum) {
    CustomerPaidShippingRatingRatingProblemsEnum["YES"] = "YES";
    CustomerPaidShippingRatingRatingProblemsEnum["NO"] = "NO";
    return CustomerPaidShippingRatingRatingProblemsEnum;
  }({});
  _BackendPublicEnums.CustomerPaidShippingRatingRatingProblemsEnum = CustomerPaidShippingRatingRatingProblemsEnum;
  let CustomerPaidShippingRatingRatingSatisfactionEnum = /*#__PURE__*/function (CustomerPaidShippingRatingRatingSatisfactionEnum) {
    CustomerPaidShippingRatingRatingSatisfactionEnum[CustomerPaidShippingRatingRatingSatisfactionEnum["VALUE_2"] = 2] = "VALUE_2";
    CustomerPaidShippingRatingRatingSatisfactionEnum[CustomerPaidShippingRatingRatingSatisfactionEnum["VALUE_1"] = 1] = "VALUE_1";
    CustomerPaidShippingRatingRatingSatisfactionEnum[CustomerPaidShippingRatingRatingSatisfactionEnum["VALUE_0"] = 0] = "VALUE_0";
    return CustomerPaidShippingRatingRatingSatisfactionEnum;
  }({});
  _BackendPublicEnums.CustomerPaidShippingRatingRatingSatisfactionEnum = CustomerPaidShippingRatingRatingSatisfactionEnum;
  let CustomerRatingEnum = /*#__PURE__*/function (CustomerRatingEnum) {
    CustomerRatingEnum[CustomerRatingEnum["VALUE_0"] = 0] = "VALUE_0";
    CustomerRatingEnum[CustomerRatingEnum["VALUE_1"] = 1] = "VALUE_1";
    CustomerRatingEnum[CustomerRatingEnum["VALUE_2"] = 2] = "VALUE_2";
    return CustomerRatingEnum;
  }({});
  _BackendPublicEnums.CustomerRatingEnum = CustomerRatingEnum;
  let DropOffBranchShippingProvidersEnum = /*#__PURE__*/function (DropOffBranchShippingProvidersEnum) {
    DropOffBranchShippingProvidersEnum["ZASILKOVNA"] = "ZASILKOVNA";
    DropOffBranchShippingProvidersEnum["MY_GLS_DROPOFF"] = "MY_GLS_DROPOFF";
    DropOffBranchShippingProvidersEnum["DPD_DROPOFF"] = "DPD_DROPOFF";
    DropOffBranchShippingProvidersEnum["RETINO_PPL"] = "RETINO_PPL";
    DropOffBranchShippingProvidersEnum["CUSTOMER_RETINO_PPL"] = "CUSTOMER_RETINO_PPL";
    DropOffBranchShippingProvidersEnum["CUSTOMER_RETINO_GLS_DROPOFF"] = "CUSTOMER_RETINO_GLS_DROPOFF";
    DropOffBranchShippingProvidersEnum["LIFTAGO_RETINO_PPL"] = "LIFTAGO_RETINO_PPL";
    DropOffBranchShippingProvidersEnum["GLS_DROPOFF_PL"] = "GLS_DROPOFF_PL";
    DropOffBranchShippingProvidersEnum["RETURN_CONNECT"] = "RETURN_CONNECT";
    DropOffBranchShippingProvidersEnum["DHL_DROPOFF"] = "DHL_DROPOFF";
    return DropOffBranchShippingProvidersEnum;
  }({});
  _BackendPublicEnums.DropOffBranchShippingProvidersEnum = DropOffBranchShippingProvidersEnum;
  let ExchangeTypeEnum = /*#__PURE__*/function (ExchangeTypeEnum) {
    ExchangeTypeEnum["SWAP"] = "SWAP";
    ExchangeTypeEnum["CREDIT"] = "CREDIT";
    return ExchangeTypeEnum;
  }({});
  _BackendPublicEnums.ExchangeTypeEnum = ExchangeTypeEnum;
  let ExclusionEnum = /*#__PURE__*/function (ExclusionEnum) {
    ExclusionEnum["NO_EXCHANGE"] = "NO_EXCHANGE";
    return ExclusionEnum;
  }({});
  _BackendPublicEnums.ExclusionEnum = ExclusionEnum;
  let FileUploadCreateStatusEnum = /*#__PURE__*/function (FileUploadCreateStatusEnum) {
    FileUploadCreateStatusEnum["UPLOADED"] = "UPLOADED";
    FileUploadCreateStatusEnum["FAILED_UPLOAD"] = "FAILED_UPLOAD";
    FileUploadCreateStatusEnum["UPLOADING"] = "UPLOADING";
    return FileUploadCreateStatusEnum;
  }({});
  _BackendPublicEnums.FileUploadCreateStatusEnum = FileUploadCreateStatusEnum;
  let ItemTypeEnum = /*#__PURE__*/function (ItemTypeEnum) {
    ItemTypeEnum[ItemTypeEnum["VALUE_1"] = 1] = "VALUE_1";
    ItemTypeEnum[ItemTypeEnum["VALUE_2"] = 2] = "VALUE_2";
    ItemTypeEnum[ItemTypeEnum["VALUE_3"] = 3] = "VALUE_3";
    ItemTypeEnum[ItemTypeEnum["VALUE_4"] = 4] = "VALUE_4";
    ItemTypeEnum[ItemTypeEnum["VALUE_5"] = 5] = "VALUE_5";
    ItemTypeEnum[ItemTypeEnum["VALUE_6"] = 6] = "VALUE_6";
    return ItemTypeEnum;
  }({});
  _BackendPublicEnums.ItemTypeEnum = ItemTypeEnum;
  let LabelTypeEnum = /*#__PURE__*/function (LabelTypeEnum) {
    LabelTypeEnum["PRINT_LABEL"] = "PRINT_LABEL";
    LabelTypeEnum["QR_CODE"] = "QR_CODE";
    LabelTypeEnum["DROP_OFF_CODE"] = "DROP_OFF_CODE";
    return LabelTypeEnum;
  }({});
  _BackendPublicEnums.LabelTypeEnum = LabelTypeEnum;
  let LabelTypesEnum = /*#__PURE__*/function (LabelTypesEnum) {
    LabelTypesEnum["PRINT_LABEL"] = "PRINT_LABEL";
    LabelTypesEnum["QR_CODE"] = "QR_CODE";
    LabelTypesEnum["DROP_OFF_CODE"] = "DROP_OFF_CODE";
    return LabelTypesEnum;
  }({});
  _BackendPublicEnums.LabelTypesEnum = LabelTypesEnum;
  let LanguageEnum = /*#__PURE__*/function (LanguageEnum) {
    LanguageEnum["EN"] = "en";
    LanguageEnum["DE"] = "de";
    LanguageEnum["DE-AT"] = "de-at";
    LanguageEnum["DE-CH"] = "de-ch";
    LanguageEnum["CS"] = "cs";
    LanguageEnum["SK"] = "sk";
    LanguageEnum["PL"] = "pl";
    LanguageEnum["HU"] = "hu";
    LanguageEnum["RO"] = "ro";
    LanguageEnum["ES"] = "es";
    LanguageEnum["IT"] = "it";
    LanguageEnum["IT-CH"] = "it-ch";
    LanguageEnum["FR"] = "fr";
    LanguageEnum["FR-CH"] = "fr-ch";
    LanguageEnum["FR-BE"] = "fr-be";
    LanguageEnum["HR"] = "hr";
    LanguageEnum["BG"] = "bg";
    LanguageEnum["SL"] = "sl";
    LanguageEnum["EL"] = "el";
    LanguageEnum["NL"] = "nl";
    LanguageEnum["NL-BE"] = "nl-be";
    LanguageEnum["NB"] = "nb";
    LanguageEnum["LV"] = "lv";
    LanguageEnum["LT"] = "lt";
    LanguageEnum["ET"] = "et";
    LanguageEnum["DA"] = "da";
    LanguageEnum["SV"] = "sv";
    LanguageEnum["FI"] = "fi";
    LanguageEnum["PT"] = "pt";
    LanguageEnum["UK"] = "uk";
    LanguageEnum["SR"] = "sr";
    return LanguageEnum;
  }({});
  _BackendPublicEnums.LanguageEnum = LanguageEnum;
  let NoShippingReasonEnum = /*#__PURE__*/function (NoShippingReasonEnum) {
    NoShippingReasonEnum["DELIVERY_IN_PERSON"] = "DELIVERY_IN_PERSON";
    NoShippingReasonEnum["HIGH_PRICES"] = "HIGH_PRICES";
    NoShippingReasonEnum["MISSING_SHIPPING_TYPE"] = "MISSING_SHIPPING_TYPE";
    NoShippingReasonEnum["BAD_EXPERIENCE"] = "BAD_EXPERIENCE";
    NoShippingReasonEnum["OTHER"] = "OTHER";
    return NoShippingReasonEnum;
  }({});
  _BackendPublicEnums.NoShippingReasonEnum = NoShippingReasonEnum;
  let PlatformIntegrationDataStateEnum = /*#__PURE__*/function (PlatformIntegrationDataStateEnum) {
    PlatformIntegrationDataStateEnum["NEW"] = "NEW";
    PlatformIntegrationDataStateEnum["COMPLETED"] = "COMPLETED";
    return PlatformIntegrationDataStateEnum;
  }({});
  _BackendPublicEnums.PlatformIntegrationDataStateEnum = PlatformIntegrationDataStateEnum;
  let PlatformIntegrationDataTypeEnum = /*#__PURE__*/function (PlatformIntegrationDataTypeEnum) {
    PlatformIntegrationDataTypeEnum["SHOPTET_API"] = "SHOPTET_API";
    PlatformIntegrationDataTypeEnum["RETINO_XML"] = "RETINO_XML";
    PlatformIntegrationDataTypeEnum["PRESTASHOP_16"] = "PRESTASHOP_16";
    PlatformIntegrationDataTypeEnum["UPGATES_API"] = "UPGATES_API";
    PlatformIntegrationDataTypeEnum["SHOPIFY_PRIVATE"] = "SHOPIFY_PRIVATE";
    PlatformIntegrationDataTypeEnum["SHOPIFY_API"] = "SHOPIFY_API";
    PlatformIntegrationDataTypeEnum["SIMPLIA_API"] = "SIMPLIA_API";
    PlatformIntegrationDataTypeEnum["SHOPRENTER_API"] = "SHOPRENTER_API";
    PlatformIntegrationDataTypeEnum["WEBAREAL_API"] = "WEBAREAL_API";
    PlatformIntegrationDataTypeEnum["SHOPWARE_5"] = "SHOPWARE_5";
    PlatformIntegrationDataTypeEnum["SHOPWARE_6"] = "SHOPWARE_6";
    PlatformIntegrationDataTypeEnum["BYZNYSWEB_API"] = "BYZNYSWEB_API";
    PlatformIntegrationDataTypeEnum["WOOCOMMERCE_API"] = "WOOCOMMERCE_API";
    PlatformIntegrationDataTypeEnum["RETINO_ORDERS_API"] = "RETINO_ORDERS_API";
    PlatformIntegrationDataTypeEnum["UNAS_API"] = "UNAS_API";
    PlatformIntegrationDataTypeEnum["ESHOP_RYCHLE_API"] = "ESHOP_RYCHLE_API";
    PlatformIntegrationDataTypeEnum["IDOSELL_API"] = "IDOSELL_API";
    return PlatformIntegrationDataTypeEnum;
  }({});
  _BackendPublicEnums.PlatformIntegrationDataTypeEnum = PlatformIntegrationDataTypeEnum;
  let PortalFormProgressStateEnum = /*#__PURE__*/function (PortalFormProgressStateEnum) {
    PortalFormProgressStateEnum["PRODUCTS"] = "PRODUCTS";
    PortalFormProgressStateEnum["EXCHANGE_SUMMARY"] = "EXCHANGE_SUMMARY";
    PortalFormProgressStateEnum["SHIPPING"] = "SHIPPING";
    PortalFormProgressStateEnum["REFUNDS"] = "REFUNDS";
    PortalFormProgressStateEnum["CUSTOMER"] = "CUSTOMER";
    PortalFormProgressStateEnum["SUMMARY"] = "SUMMARY";
    PortalFormProgressStateEnum["RESULT"] = "RESULT";
    return PortalFormProgressStateEnum;
  }({});
  _BackendPublicEnums.PortalFormProgressStateEnum = PortalFormProgressStateEnum;
  let ProductCustomFieldTypeEnum = /*#__PURE__*/function (ProductCustomFieldTypeEnum) {
    ProductCustomFieldTypeEnum["CHAR"] = "CHAR";
    ProductCustomFieldTypeEnum["MULTILINE"] = "MULTILINE";
    ProductCustomFieldTypeEnum["DATE"] = "DATE";
    ProductCustomFieldTypeEnum["SELECT"] = "SELECT";
    ProductCustomFieldTypeEnum["FILE"] = "FILE";
    ProductCustomFieldTypeEnum["LINK"] = "LINK";
    return ProductCustomFieldTypeEnum;
  }({});
  _BackendPublicEnums.ProductCustomFieldTypeEnum = ProductCustomFieldTypeEnum;
  let ProductFieldEnum = /*#__PURE__*/function (ProductFieldEnum) {
    ProductFieldEnum["MANUFACTURER"] = "manufacturer";
    ProductFieldEnum["CATEGORY"] = "category";
    ProductFieldEnum["VARIANT"] = "variant";
    ProductFieldEnum["PRODUCT_ID"] = "product_id";
    ProductFieldEnum["EAN"] = "ean";
    ProductFieldEnum["SERIAL"] = "serial";
    return ProductFieldEnum;
  }({});
  _BackendPublicEnums.ProductFieldEnum = ProductFieldEnum;
  let RatingShippingProviderReasonEnum = /*#__PURE__*/function (RatingShippingProviderReasonEnum) {
    RatingShippingProviderReasonEnum["LOW_PRICE"] = "LOW_PRICE";
    RatingShippingProviderReasonEnum["SPEED"] = "SPEED";
    RatingShippingProviderReasonEnum["MANY_PARCEL_SHOPS"] = "MANY_PARCEL_SHOPS";
    RatingShippingProviderReasonEnum["OTHER"] = "OTHER";
    return RatingShippingProviderReasonEnum;
  }({});
  _BackendPublicEnums.RatingShippingProviderReasonEnum = RatingShippingProviderReasonEnum;
  let RefundOptionTypeEnum = /*#__PURE__*/function (RefundOptionTypeEnum) {
    RefundOptionTypeEnum["TO_BANK_ACCOUNT"] = "TO_BANK_ACCOUNT";
    RefundOptionTypeEnum["VOUCHER"] = "VOUCHER";
    RefundOptionTypeEnum["CUSTOM"] = "CUSTOM";
    RefundOptionTypeEnum["WEBHOOK"] = "WEBHOOK";
    return RefundOptionTypeEnum;
  }({});
  _BackendPublicEnums.RefundOptionTypeEnum = RefundOptionTypeEnum;
  let SelectedProductsEnum = /*#__PURE__*/function (SelectedProductsEnum) {
    SelectedProductsEnum["MANAGER"] = "MANAGER";
    SelectedProductsEnum["TRACKING"] = "TRACKING";
    return SelectedProductsEnum;
  }({});
  _BackendPublicEnums.SelectedProductsEnum = SelectedProductsEnum;
  let ShippingPriceEnum = /*#__PURE__*/function (ShippingPriceEnum) {
    ShippingPriceEnum["BEFOREDISCOUNT"] = "beforeDiscount";
    ShippingPriceEnum["CART"] = "cart";
    ShippingPriceEnum["FREE"] = "free";
    return ShippingPriceEnum;
  }({});
  _BackendPublicEnums.ShippingPriceEnum = ShippingPriceEnum;
  let ShippingProvidersEnum = /*#__PURE__*/function (ShippingProvidersEnum) {
    ShippingProvidersEnum["CUSTOM"] = "CUSTOM";
    ShippingProvidersEnum["DHL24_PICKUP"] = "DHL24_PICKUP";
    ShippingProvidersEnum["DHL24_DROP_OFF"] = "DHL24_DROP_OFF";
    ShippingProvidersEnum["DHL_FREIGHT_PICKUP"] = "DHL_FREIGHT_PICKUP";
    ShippingProvidersEnum["DHL_INTERNATIONAL_DROPOFF"] = "DHL_INTERNATIONAL_DROPOFF";
    ShippingProvidersEnum["DPD_BELGIUM_DROPOFF"] = "DPD_BELGIUM_DROPOFF";
    ShippingProvidersEnum["DPD_GEO_API_DROPOFF"] = "DPD_GEO_API_DROPOFF";
    ShippingProvidersEnum["DPD_GEO_API_PICKUP"] = "DPD_GEO_API_PICKUP";
    ShippingProvidersEnum["DPD_HU_DROPOFF"] = "DPD_HU_DROPOFF";
    ShippingProvidersEnum["DPD_HU_PICKUP"] = "DPD_HU_PICKUP";
    ShippingProvidersEnum["DPD_REG_PRIJEMCE_PICKUP"] = "DPD_REG_PRIJEMCE_PICKUP";
    ShippingProvidersEnum["DPD_REG_PRIJEMCE_DROPOFF"] = "DPD_REG_PRIJEMCE_DROPOFF";
    ShippingProvidersEnum["DPD_SK_PICKUP"] = "DPD_SK_PICKUP";
    ShippingProvidersEnum["DPD_SK_DROPOFF"] = "DPD_SK_DROPOFF";
    ShippingProvidersEnum["FOXPOST_RETURNS"] = "FOXPOST_RETURNS";
    ShippingProvidersEnum["GEIS_PICKUP"] = "GEIS_PICKUP";
    ShippingProvidersEnum["GLS_PICKUP"] = "GLS_PICKUP";
    ShippingProvidersEnum["GLS_ISRS"] = "GLS_ISRS";
    ShippingProvidersEnum["GLS_POLAND_API_DROPOFF"] = "GLS_POLAND_API_DROPOFF";
    ShippingProvidersEnum["IN_PERSON"] = "IN_PERSON";
    ShippingProvidersEnum["INPOST_DROP_OFF"] = "INPOST_DROP_OFF";
    ShippingProvidersEnum["INPOST_PICKUP"] = "INPOST_PICKUP";
    ShippingProvidersEnum["LIFTAGO"] = "LIFTAGO";
    ShippingProvidersEnum["MY_GLS_DROP_OFF_CZ"] = "MY_GLS_DROP_OFF_CZ";
    ShippingProvidersEnum["MY_GLS_DROP_OFF_SK"] = "MY_GLS_DROP_OFF_SK";
    ShippingProvidersEnum["MY_GLS_DROP_OFF_HU"] = "MY_GLS_DROP_OFF_HU";
    ShippingProvidersEnum["MY_GLS_BOX_CZ"] = "MY_GLS_BOX_CZ";
    ShippingProvidersEnum["MY_GLS_PICKUP_CZ"] = "MY_GLS_PICKUP_CZ";
    ShippingProvidersEnum["MY_GLS_PICKUP_SK"] = "MY_GLS_PICKUP_SK";
    ShippingProvidersEnum["MY_GLS_PICKUP_HU"] = "MY_GLS_PICKUP_HU";
    ShippingProvidersEnum["MY_GLS_PICKUP_SI"] = "MY_GLS_PICKUP_SI";
    ShippingProvidersEnum["MY_GLS_PICKUP_HR"] = "MY_GLS_PICKUP_HR";
    ShippingProvidersEnum["MY_PPL_PICKUP"] = "MY_PPL_PICKUP";
    ShippingProvidersEnum["PACKETA_CLAIM_ASSISTANT"] = "PACKETA_CLAIM_ASSISTANT";
    ShippingProvidersEnum["MY_PPL_CPL_DROPOFF"] = "MY_PPL_CPL_DROPOFF";
    ShippingProvidersEnum["MY_PPL_CPL_PICKUP"] = "MY_PPL_CPL_PICKUP";
    ShippingProvidersEnum["PPL_RETURN_CONNECT_DROPOFF"] = "PPL_RETURN_CONNECT_DROPOFF";
    ShippingProvidersEnum["PPL_RETURN_CONNECT_PICKUP"] = "PPL_RETURN_CONNECT_PICKUP";
    ShippingProvidersEnum["RABEN_FREIGHT"] = "RABEN_FREIGHT";
    ShippingProvidersEnum["SPS_DROPOFF"] = "SPS_DROPOFF";
    ShippingProvidersEnum["UPS_PICKUP"] = "UPS_PICKUP";
    return ShippingProvidersEnum;
  }({});
  _BackendPublicEnums.ShippingProvidersEnum = ShippingProvidersEnum;
  let ShippingRatingRatingIntuitivityEnum = /*#__PURE__*/function (ShippingRatingRatingIntuitivityEnum) {
    ShippingRatingRatingIntuitivityEnum["YES"] = "YES";
    ShippingRatingRatingIntuitivityEnum["MAYBE"] = "MAYBE";
    ShippingRatingRatingIntuitivityEnum["NO"] = "NO";
    return ShippingRatingRatingIntuitivityEnum;
  }({});
  _BackendPublicEnums.ShippingRatingRatingIntuitivityEnum = ShippingRatingRatingIntuitivityEnum;
  let ShippingRatingRatingSatisfactionEnum = /*#__PURE__*/function (ShippingRatingRatingSatisfactionEnum) {
    ShippingRatingRatingSatisfactionEnum[ShippingRatingRatingSatisfactionEnum["VALUE_2"] = 2] = "VALUE_2";
    ShippingRatingRatingSatisfactionEnum[ShippingRatingRatingSatisfactionEnum["VALUE_1"] = 1] = "VALUE_1";
    ShippingRatingRatingSatisfactionEnum[ShippingRatingRatingSatisfactionEnum["VALUE_0"] = 0] = "VALUE_0";
    return ShippingRatingRatingSatisfactionEnum;
  }({});
  _BackendPublicEnums.ShippingRatingRatingSatisfactionEnum = ShippingRatingRatingSatisfactionEnum;
  let ShippingStatusEnum = /*#__PURE__*/function (ShippingStatusEnum) {
    ShippingStatusEnum["CONFIRMATION_REQUIRED"] = "CONFIRMATION_REQUIRED";
    ShippingStatusEnum["WAITING"] = "WAITING";
    ShippingStatusEnum["SYNCING"] = "SYNCING";
    ShippingStatusEnum["FINISHED"] = "FINISHED";
    ShippingStatusEnum["REFUNDED"] = "REFUNDED";
    ShippingStatusEnum["CANCELED"] = "CANCELED";
    ShippingStatusEnum["DECLINED"] = "DECLINED";
    ShippingStatusEnum["FAILURE"] = "FAILURE";
    ShippingStatusEnum["VOIDED"] = "VOIDED";
    return ShippingStatusEnum;
  }({});
  _BackendPublicEnums.ShippingStatusEnum = ShippingStatusEnum;
  let ShoptetVoucherDiscountTypeEnum = /*#__PURE__*/function (ShoptetVoucherDiscountTypeEnum) {
    ShoptetVoucherDiscountTypeEnum["FIXED"] = "fixed";
    ShoptetVoucherDiscountTypeEnum["PERCENTUAL"] = "percentual";
    return ShoptetVoucherDiscountTypeEnum;
  }({});
  _BackendPublicEnums.ShoptetVoucherDiscountTypeEnum = ShoptetVoucherDiscountTypeEnum;
  let SubmitTypeEnum = /*#__PURE__*/function (SubmitTypeEnum) {
    SubmitTypeEnum["DROP_OFF"] = "DROP_OFF";
    SubmitTypeEnum["PICKUP"] = "PICKUP";
    SubmitTypeEnum["FREIGHT"] = "FREIGHT";
    SubmitTypeEnum["CUSTOM"] = "CUSTOM";
    SubmitTypeEnum["IN_PERSON"] = "IN_PERSON";
    return SubmitTypeEnum;
  }({});
  _BackendPublicEnums.SubmitTypeEnum = SubmitTypeEnum;
  let TicketFieldEnum = /*#__PURE__*/function (TicketFieldEnum) {
    TicketFieldEnum["ORDER_ID"] = "order_id";
    TicketFieldEnum["CUSTOMER_EMAIL"] = "customer_email";
    TicketFieldEnum["CUSTOMER_NAME"] = "customer_name";
    TicketFieldEnum["CUSTOMER_PHONE"] = "customer_phone";
    return TicketFieldEnum;
  }({});
  _BackendPublicEnums.TicketFieldEnum = TicketFieldEnum;
  let TicketMessageTypeEnum = /*#__PURE__*/function (TicketMessageTypeEnum) {
    TicketMessageTypeEnum["AGENT_MESSAGE"] = "AGENT_MESSAGE";
    TicketMessageTypeEnum["CUSTOMER_MESSAGE"] = "CUSTOMER_MESSAGE";
    TicketMessageTypeEnum["OTHERS_MESSAGE"] = "OTHERS_MESSAGE";
    TicketMessageTypeEnum["EMAIL"] = "EMAIL";
    TicketMessageTypeEnum["SMS"] = "SMS";
    return TicketMessageTypeEnum;
  }({});
  _BackendPublicEnums.TicketMessageTypeEnum = TicketMessageTypeEnum;
  let TransportStatusEnum = /*#__PURE__*/function (TransportStatusEnum) {
    TransportStatusEnum["STATUS_PENDING_CONFIRMATION"] = "STATUS_PENDING_CONFIRMATION";
    TransportStatusEnum["STATUS_INIT"] = "STATUS_INIT";
    TransportStatusEnum["STATUS_ACCEPTED"] = "STATUS_ACCEPTED";
    TransportStatusEnum["STATUS_SUBMITTED"] = "STATUS_SUBMITTED";
    TransportStatusEnum["STATUS_TRANSPORT"] = "STATUS_TRANSPORT";
    TransportStatusEnum["STATUS_DELIVERED"] = "STATUS_DELIVERED";
    TransportStatusEnum["STATUS_UNDELIVERED"] = "STATUS_UNDELIVERED";
    TransportStatusEnum["STATUS_CANCELED"] = "STATUS_CANCELED";
    TransportStatusEnum["STATUS_WAITING_FOR_ORDERING"] = "STATUS_WAITING_FOR_ORDERING";
    TransportStatusEnum["STATUS_REFUNDED"] = "STATUS_REFUNDED";
    TransportStatusEnum["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
    return TransportStatusEnum;
  }({});
  _BackendPublicEnums.TransportStatusEnum = TransportStatusEnum;
  let WooCommerceVoucherDiscountTypeEnum = /*#__PURE__*/function (WooCommerceVoucherDiscountTypeEnum) {
    WooCommerceVoucherDiscountTypeEnum["FIXED_CART"] = "fixed_cart";
    WooCommerceVoucherDiscountTypeEnum["PERCENT"] = "percent";
    WooCommerceVoucherDiscountTypeEnum["FIXED_PRODUCT"] = "fixed_product";
    WooCommerceVoucherDiscountTypeEnum["PERCENT_PRODUCT"] = "percent_product";
    return WooCommerceVoucherDiscountTypeEnum;
  }({});
  _BackendPublicEnums.WooCommerceVoucherDiscountTypeEnum = WooCommerceVoucherDiscountTypeEnum;
  let YesNoEnum = /*#__PURE__*/function (YesNoEnum) {
    YesNoEnum["YES"] = "YES";
    YesNoEnum["NO"] = "NO";
    return YesNoEnum;
  }({});
  _BackendPublicEnums.YesNoEnum = YesNoEnum;
})(BackendPublicEnums || (BackendPublicEnums = {}));

/***/ })

}]);